import styled from 'styled-components';

export const MasterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 66px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const LeftContainer = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 30px;
  border-right: 1px solid #9489FF;
`;

export const LeftInnerContainer = styled.div`
  position: sticky;
  top: 90px;
`;


